(() => {
  const selector = [
    '.product-information .product-details h1',
    'product-card [role="heading"]',
    '.product-card__title',
    '.cart-items__title',
    '.sticky-add-to-cart__title',
    '.quick-add-modal h1',
    'quick-add-modal h1',
    '.quick-add-modal [data-product-title]',
    'quick-add-modal [data-product-title]',
    'predictive-search [role="heading"]',
    '.search-modal [role="heading"]'
  ].join(',');

  const parseTitle = (value) => {
    const parts = value
      .split(/\s*\|\s*/)
      .map((part) => part.trim())
      .filter(Boolean);

    if (parts.length < 2) return null;

    return {
      name: parts.shift(),
      inspired: parts.join(' | '),
    };
  };

  const createSpan = (className, text) => {
    const span = document.createElement('span');
    span.className = className;
    span.textContent = text;
    return span;
  };

  const directAnchor = (element) => {
    if (element.tagName === 'A') return element;
    if (element.children.length === 1 && element.firstElementChild?.tagName === 'A') {
      return element.firstElementChild;
    }
    return null;
  };

  const splitElement = (element) => {
    if (!(element instanceof HTMLElement)) return;

    const anchor = directAnchor(element);
    const target = anchor || element;
    const rawTitle = target.textContent.replace(/\s+/g, ' ').trim();
    const parsed = parseTitle(rawTitle);

    if (!parsed) {
      if (!target.querySelector('.osmodi-product-name-main')) {
        target.classList.add('osmodi-product-name-main');
      }
      target.dataset.osmodiProductNameProcessed = 'true';
      return;
    }

    const oldGeneratedSubtitle = element.nextElementSibling;
    if (oldGeneratedSubtitle?.dataset.osmodiProductNameGenerated === 'true') {
      oldGeneratedSubtitle.remove();
    }

    target.dataset.osmodiFullProductTitle = rawTitle;
    target.dataset.osmodiProductNameProcessed = 'true';

    if (target.tagName === 'A' || target !== element) {
      target.textContent = '';
      target.classList.remove('osmodi-product-name-main');
      target.classList.add('osmodi-product-name-stack');
      target.append(
        createSpan('osmodi-product-name-main', parsed.name),
        createSpan('osmodi-product-name-inspired', parsed.inspired)
      );
      return;
    }

    target.textContent = parsed.name;
    target.classList.add('osmodi-product-name-main');

    const subtitle = document.createElement(
      element.matches('h1,h2,h3,h4,h5,h6,p') ? 'p' : 'span'
    );
    subtitle.className = 'osmodi-product-name-inspired';
    subtitle.textContent = parsed.inspired;
    subtitle.dataset.osmodiProductNameGenerated = 'true';
    element.insertAdjacentElement('afterend', subtitle);
  };

  const process = (root = document) => {
    if (root instanceof Element && root.matches(selector)) splitElement(root);
    root.querySelectorAll?.(selector).forEach(splitElement);
  };

  const start = () => {
    process(document);

    const observer = new MutationObserver((records) => {
      for (const record of records) {
        record.addedNodes.forEach((node) => {
          if (node instanceof Element) process(node);
        });
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    document.addEventListener('shopify:section:load', (event) => process(event.target));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
